
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[league]/betting-record",
      function () {
        return require("private-next-pages/[league]/betting-record/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[league]/betting-record"])
      });
    }
  